import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject, output } from '@angular/core';
import {Router} from "@angular/router";
import BreadCrumbService from "../services/bread-crumb.service";

import type BreadCrumbPath from "../bread-crumb";
import type {Subscription} from "rxjs";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-bread-crumb',
    templateUrl: './bread-crumb.component.html',
    styleUrls: ['./bread-crumb.component.scss'],
    imports: [
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadCrumbComponent implements OnInit, OnDestroy {
  private breadCrumbService = inject(BreadCrumbService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);


  readonly pathClicked = output<BreadCrumbPath>();
  path: BreadCrumbPath [];
  sub: Subscription;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  ngOnInit(): void {
    this.sub = this.breadCrumbService.path.subscribe(path => {
      this.path = path;
      this.cdr.markForCheck();
    })
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  brearCrumbNavigate(segment: BreadCrumbPath) {
    this.pathClicked.emit(segment);
    this.router.navigate([segment.url], {queryParams: segment.query});
  }

}
